<template lang="pug">
div
  app-divider(label="Interessado")
  div.pad5
    p(v-if="interessado.espolio !== null && !isProcessoFisico")
      span.label É espólio?
      span &nbsp {{isEspolio}}
    div(v-if="interessado.pessoa.tipo === 'PF'")
      app-resumo-pessoa-fisica(
        :pessoa="interessado.pessoa.pessoaFisica",
        :isCadastro="true"
      )
      el-row.labelDiv
        el-col(:span="12" v-if="isProcessoFisico")
          p
            span.label Tipo de documento:
            span &nbsp {{filterNull(interessado.pessoa.pessoaFisica.tipoDocumento)}}
        el-col(:span="12" v-if="interessado.pessoa.pessoaFisica.tipoDocumento == 'OUTROS'")
          p
            span.label Outros:
            span &nbsp {{filterNull(interessado.pessoa.pessoaFisica.outrosTipoDocumento)}}
        el-col(v-if="!isProcessoFisico" :span="12")
          p
            span.label Email:
            span &nbsp {{interessado.pessoa.email}}
        el-col(:span="12" v-if="isLiberacao")
          p
            span.label Profissão:
            span &nbsp {{interessado.pessoa.pessoaFisica.profissao}}
        el-col(:span="12")
          p
            span.label Estado civil:
            span &nbsp {{getEstadoCivil(interessado.pessoa.pessoaFisica.estadoCivil)}}
        el-col.labelTel(:span="12")
          p
            span.label Telefone(s):
            span(v-if="interessado.pessoa.telefones && !interessado.pessoa.telefones.length") &nbsp {{ '-' }}
            span(v-for="item in interessado.pessoa.telefones") &nbsp {{ item }}
    div(v-else)
      el-row
        el-col(:span="12")
          p
            span.label CNPJ:
            span &nbsp {{filterNull(interessado.pessoa.pessoaJuridica.cnpj)}}
        el-col(:span="12")
          p
            span.label Razão Social:
            span &nbsp {{filterNull(interessado.pessoa.pessoaJuridica.razaoSocial)}}
        el-col(:span="12" v-if="!isProcessoFisico")
          p
            span.label Telefone(s):
            span(v-for="item in interessado.pessoa.telefones") &nbsp {{ item }}
        el-col(:span="12" v-if="!isProcessoFisico")
          p
            span.label E-mail:
            span &nbsp {{getEmail()}}
        el-col(:span="12" v-if="isProcessoFisico")
          p
            span.label Nome do presidente da associação/empresa:
            span &nbsp {{filterNull(interessado.pessoa.pessoaJuridica.presidenteAssociacao.nome)}}
        el-col(:span="12" v-if="isProcessoFisico")
          p
            span.label CPF:
            span &nbsp {{filterNull(interessado.pessoa.pessoaJuridica.presidenteAssociacao.cpf)}},
        el-col(:span="12" v-if="isProcessoFisico")
          p
            span.label RG:
            span &nbsp {{filterNull(interessado.pessoa.pessoaJuridica.presidenteAssociacao.rg)}}
        el-col(:span="12" v-if="isProcessoFisico")
          p
            span.label UF do RG:
            span &nbsp {{getUfRg(interessado.pessoa.pessoaJuridica.presidenteAssociacao) || '-'}}
        el-col(:span="12" v-if="isProcessoFisico")
          p
            span.label Tipo de documento:
            span &nbsp {{filterNull(interessado.pessoa.pessoaJuridica.presidenteAssociacao.tipoDocumento)}}
        el-col(:span="12" v-if="interessado.pessoa.pessoaJuridica.presidenteAssociacao.tipoDocumento == 'OUTROS'")
          p
            span.label Outros:
            span &nbsp {{filterNull(interessado.pessoa.pessoaJuridica.presidenteAssociacao.outrosTipoDocumento)}}
        el-col(:span="12" v-if="isProcessoFisico")
          p
            span.label Órgão expedidor:
            span &nbsp {{getOrgaoExpedidor(interessado.pessoa.pessoaJuridica.presidenteAssociacao.orgaoExpedidor)}}
    p
    app-resumo-endereco(v-if="!isProcessoFisico" :endereco="interessado.pessoa.endereco")
    br
    div(v-if="hasConjuge")
      div(v-if="isCasado")
        app-divider(label="Dados do cônjuge")
        app-resumo-pessoa-fisica.pad5(
          :pessoa="interessado.conjuge.pessoaFisica",
          :isCadastro="true"
          :isProcessoFisicoConjuge="true"
        )
      div(v-if="isViuvo && !isProcessoFisico")
        app-divider(label="Dados do cônjuge")
        div.pad5
          p
            span.label CPF:
            span &nbsp {{filterNull(interessado.conjuge.pessoaFisica.cpf)}}
          p
            span.label Nome:
            span &nbsp {{filterNull(interessado.conjuge.pessoaFisica.nome)}}
          p
            span.label Possui certidão de óbito?
            span &nbsp {{hasCertidao}}
    div(v-if="hasSocios")
      app-divider(label="Sócios")
      app-resumo-socios(:socios="interessado.socios")
      br
    app-resumo-documentos(:documentos="interessado.documentos", codigoCadastro="interessado", :idCadastro="idCadastro", :isProcessoFisico="true")
</template>
<script>
import _ from 'lodash'

import AppDivider from '../AppDivider'
import AppResumoEndereco from './AppResumoEndereco'
import AppResumoDocumentos from './AppResumoDocumentos'
import AppResumoSocios from './AppResumoSocios'
import AppResumoPessoaFisica from './AppResumoPessoaFisica'
const {estadosCivil} = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {
  components: {
    AppDivider,
    AppResumoEndereco,
    AppResumoDocumentos,
    AppResumoSocios,
    AppResumoPessoaFisica
  },
  props: {
    interessado: {
      type: Object,
      required: true
    },
    hasConjuge: {
      type: Boolean,
      default: true
    },
    idCadastro: {
      type: Number,
      required: true
    },
    isLiberacao: {
      type: Boolean,
      required: false,
      default: false
    },
    isProcessoFisico: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    filterNull (atributo) {
      if (!atributo || atributo.length === 0) {
        return '-'
      }
      return atributo
    },
    getEstadoCivil (codigo) {
      const estadoCivil = estadosCivil.filter(estadoCivil => estadoCivil.codigo === codigo)[0]
      return estadoCivil ? estadoCivil.nome : '-'
    },
    getEmail () {
      return this.interessado.pessoa.email ? this.interessado.pessoa.email : this.interessado.pessoa.pessoaJuridica.email ? this.interessado.pessoa.pessoaJuridica.email : '-'
    },
    getOrgaoExpedidor (orgao) {
      return orgao.nome ? (orgao.nome + (orgao.estado ? ' - ' + orgao.estado : '')) : '-'
    },
    getUfRg (pessoa) {
      return pessoa.orgaoExpedidor.estado ? pessoa.orgaoExpedidor.estado : pessoa.orgaoExpedidor.codigo !== null ? pessoa.codigo : '-'
    }
  },
  computed: {
    isCasado () {
      return this.interessado.pessoa.pessoaFisica &&
        ['UNIAO_ESTAVEL', 'CASADO', 'UNIAO_HOMOAFETIVA']
          .includes(this.interessado.pessoa.pessoaFisica.estadoCivil)
    },
    isViuvo () {
      return this.interessado.pessoa.pessoaFisica &&
        this.interessado.pessoa.pessoaFisica.estadoCivil === 'VIUVO'
    },
    hasSocios () {
      return !_.isEmpty(this.interessado.socios)
    },
    isEspolio () {
      return this.interessado.espolio ? 'Sim' : 'Não'
    },
    hasCertidao () {
      if (this.interessado.conjuge.pessoaFisica.possuiCertidaoObito !== null) {
        return this.interessado.conjuge.pessoaFisica.possuiCertidaoObito ? 'Sim' : 'Não'
      }
      return '-'
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  font-weight: bold;
}
.pad5 {
  padding: 25px 10px;
}

@media (max-width: 780px) {
  .labelDiv{
    display: flex;
    flex-direction: column;
  }

  .labelTel {
    width: 220px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resumo/AppResumoInteressado.vue